import { Base, Component, Prop } from '@/vue-property-decorator'
import { CommonLoading } from '@/components/business-components'
import { CustomerList } from '@/api/service/type'
import { assetsPath } from '@/utils/business-utils/assets'
import { useFooterStore } from '../../store'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import { windowOpen } from '@/utils/business-utils'
import AppTypes from '@/vue-types'
import Skin from '@/controller/Skin'
import isMobile from '@/utils/isMobile'
import style from './style.module.scss'

export interface Props {
  long?: number
  showTitle?: boolean
}

/**联系我们 */
@Component<ContactUs>({
  name: 'ContactUs'
})
export default class ContactUs extends Base {
  @Prop(AppTypes.number.def(50))
  private readonly long!: Props['long']

  store = useFooterStore()
  private get footerInfos() {
    return this.store.footerInfos
  }
  get deviceInfo() {
    return isMobile()
  }

  get otherCustomers() {
    return useMainStore().serviceInformation?.customer.otherCustomers ?? []
  }

  customerUrl = (otherCustomer: CustomerList) => {
    if (this.deviceInfo.apple.device) return otherCustomer.iosUrl
    if (this.deviceInfo.android.device) return otherCustomer.androidUrl
    return otherCustomer.pcUrl
  }

  /** 会员等级的游客模式为1 */
  get memberLevel() {
    /**试玩账号的级别 */
    const DemoLevel = 1
    return useMainStore().userInfos?.member_level ?? DemoLevel
  }

  /**根据用户层级过滤其他客服，并且只获取其他客服列表 */
  get otherCustomersByFilterUserLevel() {
    return this.otherCustomers.reduce((acc, otherCustomer) => {
      const filterOtherCustomer = otherCustomer.customerList.filter(
        (customer) =>
          customer.userLevel.split(',').includes(String(this.memberLevel))
      )
      if (filterOtherCustomer.length) {
        acc = acc.concat(filterOtherCustomer)
      }

      return acc
    }, [] as Array<CustomerList>)
  }

  render() {
    const { t } = useI18n()
    const { isTheme33 } = Skin.currentTheme()
    const contactUsList = this.otherCustomersByFilterUserLevel

    if (!contactUsList) {
      return <template></template>
    }
    return (
      <CommonLoading spinning={!contactUsList} class={['contactus-box']}>
        <div class={[style.contactUsTitle, 'contact-us-title']}>
          {t('lobby.footer.footerContactUs')}
        </div>
        <div class={[style.contactUs, 'contact-us']}>
          {contactUsList &&
            contactUsList?.map((item: CustomerList) => (
              <div
                key={item.id}
                class={style.socialItem}
                onClick={() => windowOpen(this.customerUrl(item))}
              >
                <my-img
                  src={item.imgObject}
                  alt={item.customerName}
                  width={this.long}
                  height={this.long}
                />
              </div>
            ))}
          <my-img
            src={assetsPath(
              isTheme33
                ? '/lobby_asset/31-1-common/common/home/18plus.png'
                : '/lobby_asset/common/web/common/18plus.png'
            )}
            width={this.long}
            height={this.long}
          />
        </div>
      </CommonLoading>
    )
  }
}
